import { render, staticRenderFns } from "./ApspTable.vue?vue&type=template&id=183b743d"
import script from "./ApspTable.vue?vue&type=script&lang=ts"
export * from "./ApspTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports